import React from 'react';
import TableComponent from '@/components/Table';
import { useTranslation } from 'react-i18next';
import { API } from '@/constants/api';
import { parseDateTime } from '@/utils/formatter';
import { LOG_TYPES } from '@/constants';

import './index.scss';

const colSize = 100 / 6;

function CreditLogTable() {
  const { t } = useTranslation();
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: `${colSize}%`,
      render: (_, { id }) => <span>{id}</span>,
    },
    {
      title: t('dashboard.transaction_table.created_by'),
      dataIndex: 'createdby',
      width: `${1.5 * colSize}%`,
      render: (_, { createdBy, createdAt }) => (
        <div className="created-by-container">
          {createdBy && <div className="created-by">{createdBy}</div>}
          {createdAt && (
            <div className="created-at">{parseDateTime(createdAt)}</div>
          )}
        </div>
      ),
    },
    {
      title: t('dashboard.transaction_table.type'),
      dataIndex: 'logType',
      key: 'logType',
      width: `${colSize}%`,
      render: (_, { logType }) => {
        const typeText = LOG_TYPES.find(
          (item) => item.value === logType,
        )?.label;

        return (
          <span className="text-capitalize">
            {t(`common.constants.log_type.${typeText}`)}
          </span>
        );
      },
    },
    {
      title: t('dashboard.transaction_table.detail'),
      dataIndex: 'detail',
      key: 'detail',
      width: `${1.5 * colSize}%`,
      render: (_, { detail }) => <span>{detail}</span>,
    },
    {
      title: t('subscription_page.sms_messages'),
      dataIndex: 'credit',
      key: 'credit',
      width: `${colSize}%`,
      render: (_, { creditAmount }) => (
        <span>{parseFloat(creditAmount).toLocaleString() || 0}</span>
      ),
    },
  ];

  return (
    <div className="transaction-table">
      <TableComponent columns={columns} action={API.DASHBOARD.CREDIT_LOG} />
    </div>
  );
}

CreditLogTable.propTypes = {};

export default CreditLogTable;
